export default {
  /**
   * 设置用户信息（不传值则清空用户信息）
   */
  setUserInfo(state, info) {
    const userInfo = info || {
      avatar: "",
      nickname: "",
      uuid: "",
      ticket: "",
      avatarFrameType: "",
      vipinfo: {},
    };

    state.userInfo = {
      ...state.userInfo,
      ...userInfo,
    };
  },

  setDeviceInfo(state, info) {
    state.deviceInfo = info;
  },
  setIdentity(state, info) {
    state.identity = info;
  },
};
